/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_LeadInputs */

const en_mk_cmp_lead = /** @type {(inputs: Mk_Cmp_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A short comparison against the three tools most often used instead.`)
};

const id_mk_cmp_lead = /** @type {(inputs: Mk_Cmp_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan singkat dengan tiga alat yang paling sering jadi alternatif.`)
};

/**
* | output |
* | --- |
* | "A short comparison against the three tools most often used instead." |
*
* @param {Mk_Cmp_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_lead = /** @type {((inputs?: Mk_Cmp_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_lead(inputs)
	return en_mk_cmp_lead(inputs)
});